import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: ""
}
const _hoisted_2 = {
  id: "FormContent",
  class: "centered w100 mc",
  style: {"padding-top":"10px","max-width":"500px"}
}
const _hoisted_3 = { class: "fl fw600 mt5 mr10" }
const _hoisted_4 = {
  key: 0,
  class: "fl fw600 mt7 fs11 mt5"
}
const _hoisted_5 = {
  key: 0,
  class: ""
}
const _hoisted_6 = { key: 1 }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = {
  key: 0,
  class: ""
}
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "fs11 fw600 ddgrey pointer" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_14 = {
  class: "with_white_bg",
  style: {}
}
const _hoisted_15 = {
  key: 0,
  class: "w100 yellowBg fw600 kireiOrange mt10",
  style: {"height":"50px","line-height":"50px"}
}
const _hoisted_16 = {
  key: 1,
  class: /*#__PURE__*/_normalizeClass(`rad8 kakugo calendarfirst with_white_bg ofs`)
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_18 = { class: "w100" }
const _hoisted_19 = {
  key: 0,
  class: "w100 rad8 yellowBg pad20"
}
const _hoisted_20 = { class: "fw600 fl" }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { key: 1 }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "clear mb15" }, null, -1)
const _hoisted_25 = { key: 1 }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_28 = { class: "text-left mt20" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_30 = ["tabindex"]
const _hoisted_31 = { key: 0 }
const _hoisted_32 = { key: 1 }
const _hoisted_33 = { key: 2 }
const _hoisted_34 = {
  style: {"width":"130px","padding-top":"18px"},
  class: "mc"
}
const _hoisted_35 = { class: "fl" }
const _hoisted_36 = { key: 1 }
const _hoisted_37 = {
  style: {"width":"130px","padding-top":"18px"},
  class: "mc"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormFieldContent = _resolveComponent("FormFieldContent")!
  const _component_AddAttendeesForm = _resolveComponent("AddAttendeesForm")!
  const _component_PPTosContent = _resolveComponent("PPTosContent")!
  const _component_MdProgressSpinner = _resolveComponent("MdProgressSpinner")!

  return (_ctx.showFormContent())
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (!_ctx.pdm.isInstantRoom && (_ctx.pdm.currentPd || _ctx.pdm.currentPds))
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(`w100 llgreyBg rad10 mt20 mb10 posRe ${_ctx.displayAll ? `` : `ofh`}`),
                style: _normalizeStyle({
                    padding: `8px 20px`,
                    maxHeight: _ctx.displayAll ? `` : `150px`,
                })
              }, [
                _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t(`title.selecting_dates`)), 1),
                (_ctx.showTimezone)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.pdm.currentTZDic.name), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("div", {
                  class: _normalizeClass(`pointer centered circle_button fs14 fr rad8 mt10 ${_ctx.loadingFormSending ? `lgreyBg` : `skyblueBg`}`),
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.changeDate && _ctx.changeDate(...args)))
                }, _toDisplayString(_ctx.$t(`title.change_other_dates`)), 3),
                (_ctx.Util.isPresent(_ctx.pdm.currentPd))
                  ? (_openBlock(), _createElementBlock("p", {
                      key: 1,
                      class: _normalizeClass(`fl ${_ctx.isSP ? `mt15` : `mt2`} fs18 arial`)
                    }, [
                      (_ctx.pdm.currentPd.tz_format && _ctx.showTimezone && !_ctx.isJpTimezone)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.pdm.currentPd.tz_format), 1))
                        : (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.pdm.currentPd.jp_format), 1)),
                      _hoisted_7
                    ], 2))
                  : (_ctx.Util.isPresent(_ctx.pdm.currentPds))
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 2,
                        class: _normalizeClass(["fl", `${_ctx.isSP ? `mt15` : `mt2`} `])
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pdm.currentPds, (pd, pdindex) => {
                          return (_openBlock(), _createElementBlock("p", {
                            class: _normalizeClass(`mt2 fs15 arial mr5`),
                            key: pdindex
                          }, [
                            (pd.tz_format && _ctx.showTimezone && !_ctx.isJpTimezone)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(pd.tz_format), 1))
                              : (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(pd.jp_format), 1))
                          ]))
                        }), 128)),
                        (_ctx.pdm.currentPds.length > 3)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: "posAb",
                              style: {"right":"20px","bottom":"10px"},
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.displayAll = !_ctx.displayAll))
                            }, [
                              _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.displayAll ? _ctx.$t(`schedule.hide`) : _ctx.$t(`schedule.show_all`)), 1),
                              _hoisted_11
                            ]))
                          : _createCommentVNode("", true),
                        _hoisted_12
                      ], 2))
                    : _createCommentVNode("", true),
                _hoisted_13
              ], 6))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_14, [
            (_ctx.hasInvalidFields)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(_ctx.$t(`message.some_fields_have_blank`)), 1))
              : _createCommentVNode("", true),
            (_ctx.fields)
              ? (_openBlock(), _createElementBlock("section", _hoisted_16, [
                  _hoisted_17,
                  _createElementVNode("div", _hoisted_18, [
                    (_ctx.Util.isPresent(_ctx.loggedinFields) && !_ctx.rm.hide_filled_fields)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                          _createElementVNode("p", _hoisted_20, [
                            (_ctx.loggedinStatus == `loggedin`)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_21, "ログインしているため"))
                              : (_openBlock(), _createElementBlock("span", _hoisted_22, "回答済みのため")),
                            _createTextVNode("、" + _toDisplayString(_ctx.loggedinFields.map(f => f.field_name).join(`・`)) + "の入力をスキップします。 ", 1)
                          ]),
                          (_ctx.room?.is_owner_group)
                            ? (_openBlock(), _createElementBlock("label", {
                                key: 0,
                                class: "fl label dgreyBg pointer",
                                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.resetMyForm && _ctx.resetMyForm(...args)))
                              }, "他の名前で入力する"))
                            : _createCommentVNode("", true),
                          _hoisted_23,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.loggedinFields, (field, fieldindex) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: _normalizeClass(`w100 mt20 ${field.hideField ? `nodisp` : ``}`),
                              key: `${fieldindex}${_ctx.systemUpdatedAt}`
                            }, [
                              _createVNode(_component_FormFieldContent, {
                                field: field,
                                fieldindex: fieldindex + 2,
                                editable: false,
                                updateFromChild: _ctx.updateFromChild,
                                onBlurField: _ctx.blurField
                              }, null, 8, ["field", "fieldindex", "updateFromChild", "onBlurField"]),
                              _hoisted_24
                            ], 2))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fields, (field, fieldindex) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: _normalizeClass(`w100 ${field.hideField ? `nodisp` : ``}`),
                        key: `${fieldindex}${_ctx.systemUpdatedAt}`,
                        style: _normalizeStyle(_ctx.fieldBeforeStyle())
                      }, [
                        _createVNode(_component_FormFieldContent, {
                          field: field,
                          fieldindex: fieldindex + 2,
                          editable: false,
                          updateFromChild: _ctx.updateFromChild,
                          additionalParams: _ctx.additionalParams,
                          onBlurField: _ctx.blurField
                        }, null, 8, ["field", "fieldindex", "updateFromChild", "additionalParams", "onBlurField"]),
                        _createElementVNode("div", {
                          class: "clear",
                          style: _normalizeStyle(_ctx.fieldBottomStyle())
                        }, null, 4)
                      ], 6))
                    }), 128)),
                    ([`same_event`, `other_event`].includes(_ctx.room?.room_setting?.add_event_type))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                          _createVNode(_component_AddAttendeesForm, { room: _ctx.room }, null, 8, ["room"]),
                          _createElementVNode("div", {
                            class: "clear",
                            style: _normalizeStyle(_ctx.fieldBottomStyle())
                          }, null, 4)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _hoisted_26,
                  _hoisted_27,
                  _createElementVNode("div", _hoisted_28, [
                    _createVNode(_component_PPTosContent, {
                      room: _ctx.room,
                      aform: _ctx.aform
                    }, null, 8, ["room", "aform"]),
                    _hoisted_29
                  ]),
                  (!_ctx.loadingFormSending)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: _normalizeClass(`w100 rad6 mt10 fw600 mb20 pointer ${_ctx.hasColor() ? `whiteColor` : `pinkBg`}`),
                        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.send && _ctx.send(...args))),
                        style: _normalizeStyle(_ctx.submitButtonStyle()),
                        tabindex: _ctx.fields.length + 1
                      }, [
                        (_ctx.aform?.form_submit_button_name)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString(_ctx.aform?.form_submit_button_name), 1))
                          : (_ctx.room?.room_setting?.form_submit_button_name)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_32, _toDisplayString(_ctx.room?.room_setting?.form_submit_button_name), 1))
                            : (_openBlock(), _createElementBlock("span", _hoisted_33, _toDisplayString(_ctx.currentStep == `form`
                                    ? _ctx.$t(`title.send`)
                                    : _ctx.Util.isPresent(_ctx.pdm.currentPds)
                                    ? _ctx.$t(`title.send_and_suggest`)
                                    : _ctx.$t(`title.send_and_fix`)), 1))
                      ], 14, _hoisted_30))
                    : (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        class: "w100 lgreyBg rad6 mt20 fw600 mb20 centered",
                        style: _normalizeStyle(_ctx.submitButtonLoadingStyle())
                      }, [
                        _createElementVNode("div", _hoisted_34, [
                          _createVNode(_component_MdProgressSpinner, {
                            width: "30",
                            class: "fl",
                            style: {"margin-top":"-8px"}
                          }),
                          _createElementVNode("p", _hoisted_35, "  " + _toDisplayString(_ctx.$t(`title.sending`)), 1)
                        ])
                      ], 4))
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ]))
    : (_ctx.autoSendForm)
      ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
          _createElementVNode("div", _hoisted_37, [
            _createVNode(_component_MdProgressSpinner, {
              width: "30",
              class: "fl",
              style: {"margin-top":"-8px"}
            })
          ])
        ]))
      : _createCommentVNode("", true)
}